import { render, staticRenderFns } from "./AsidesView.vue?vue&type=template&id=4c864ed6&scoped=true&"
import script from "./AsidesView.vue?vue&type=script&lang=js&"
export * from "./AsidesView.vue?vue&type=script&lang=js&"
import style0 from "./AsidesView.vue?vue&type=style&index=0&id=4c864ed6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c864ed6",
  null
  
)

export default component.exports